import React from 'react';
import { Box } from '@chakra-ui/react';
import CategoryList from '../../../pages/authorized/dashboard/components/CategoryList';

const VideosNavbar = ({ children }) => {
  return (
    <Box display="flex" flexDirection="column" minHeight="100vh" bg="#4f4f4f">
      <Box display="flex" flex="1" flexDirection="row">
        <Box flex="3" p={4}>
          {children}
        </Box>

        <Box flex="1" p={4} bg="#4f4f4f">
          <CategoryList />
        </Box>
      </Box>
    </Box>
  );
};

export default VideosNavbar;
